import { ReportsMenus, ReportsMenuThirdLevel, ReportsMenuSecondLevel, ReportsMenuFirstLevel, ReportsFlatMenus } from './models/reports-menu.model';
import { reportsMenuData, reportsMenuFlatData } from './reports-menu.data';
import { myFavListData } from './myfav-data';
import { ReportsMyFavList } from './models/reports-myfav-list.model';
import { Router } from '@angular/router';

import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { TimeConvertPipe } from '../modules/shared/pipes/timeConvert.pipe';
import { AppMainComponent } from '../app.main.component';
import { RouteManagementService } from '../more/route-management/route-management.service';
import { PermissionService } from '../service/permission.service';
import { LocalDatePipe } from '../shared/pipes/local-date.pipe';
import { ConfigurationService } from './../configurations/configurationService';
import { DataService } from './dataService';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues, typeReportsTopMenuItemsValues } from './models/reports-data-service-model';
import { ReportService } from './reportService';
import { AppMainService } from '../app-main.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css'],
    providers: [LocalDatePipe, TimeConvertPipe, DatePipe]
})

export class ReportsComponent implements OnInit, OnDestroy {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    configMenu;
    isSavedSearchReport: boolean = false;
    savedSearchId: number=0;
    selectedWindow = '';
    menuItems: any[] = [];
    reportsMenus: ReportsMenus[] = [];
    reportsMenusFlat: ReportsFlatMenus[] = reportsMenuFlatData();

    leftNavigation = true;
    @ViewChild('panel') panel: ElementRef;
    reportPermissionData;
    IsExportVisible: boolean = true;

    myFavList: ReportsMyFavList[] = myFavListData as any;
    myFavSelected: number = 0;

    constructor(
        public app: AppMainComponent, private reportService: ReportService,
        private configurationService: ConfigurationService,
        private permissionService: PermissionService,
        public localDatePipe: LocalDatePipe,
        public routeManagementService: RouteManagementService,
        private dataService: DataService,
        private router: Router ,private appMainService: AppMainService
    ) { }

    ngOnInit() {
        this.generateMyFavMenus(this.myFavList);
        //left menu expansion
        this.dataService.getData<IReportsDataServiceLeftMenuExpantionModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsLeftMenuExpansion) {
                this.selectedWindow = data.value;
                this.reBuildMenu();
            }
        });

        this.menuItems = [
            {
                label: 'Print',
                icon: 'pi pi-print',
                // command: (event) => this.print()
                command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.print)
            },
            {
                label: 'Export',
                icon: 'pi pi-upload',
                visible: this.IsExportVisible,
                items: [
                    {
                        label: 'PDF',
                        escape: false,
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.PDF)
                    },
                    {
                        label: 'XLS',
                        escape: false,
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.XLS)
                    },
                    {
                        label: 'XLSX',
                        escape: false,
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.XLSX)
                    }]
            },
            {
                label: 'Refresh',
                icon: 'pi pi-refresh',
                command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.Refresh)
            },
        ];
        this.getReportConfigData();
    }


    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

   getDynamicReportMenus(){
        this.appMainService.isShowSpinner("ReportConfigDat");
        this.reportService.getAllReportMenus().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res=>{
        this.appMainService.isHideSpinner("ReportConfigDat");
            this.reportsMenus = res;
            //check Second Levelpermission
            const updatedReportsMenus = this.reportsMenus.map(ele => ({
                ...ele,
                items: ele.items.filter(data =>
                    this.reportPermissionData.some(ele1 => (ele1?.objectName === data?.permissionName || !data?.reportType)  && (ele1?.permissions.some(permission => permission?.statusId === 1)  || !data?.reportType))
                )
            }));
            this.reportsMenus = [...updatedReportsMenus];
            const menuNames = this.reportsMenus?.map(reports=>reports.reportName);
            const processedResults = {};
            menuNames.forEach(menuName => {
                const menu = this.reportsMenus?.find(ele => ele?.reportName === menuName);
                if (menu && menu.items) {
                    processedResults[menuName] = menu.items.reduce((acc, obj) => {
                        return acc.concat(obj.items);
                    }, []);
                } else {
                    processedResults[menuName] = [];
                }
            });
            this.getMenuModule(processedResults)
        })
    }

    getMenuModule(processedResults) {
        const permisssionMenuArr = [];
        const permissionArrays = Object.keys(processedResults)?.map(key => processedResults[key]);
        const menuNames = Object.keys(processedResults);
        permissionArrays?.forEach((arr, index) => {
            const hasAccess = this.reportPermissionData?.some(checkObjName =>
                arr?.some(perm => checkObjName?.objectName === perm?.permissionName  && checkObjName.permissions.some(permission => permission.statusId === 1) )
            );
            if (hasAccess) {
                const updateMenu = this.reportsMenus?.find(item => item?.reportName === menuNames[index]);
                if (updateMenu) {
                    permisssionMenuArr.push(updateMenu);
                }
            }
        });
        this.reportsMenus = [...permisssionMenuArr];
        this.reBuildMenu();
    }

    async getReportConfigData() {
        this.appMainService.isShowSpinner("ReportConfigDat");
        const userReportsPermissions = this.permissionService.getReportsPemrissionData();
        if (userReportsPermissions?.length > 0) {
            const globalChannelId = this.permissionService.getGlobalChannelId();
            let defaultReportPermission: any;
            if (typeof globalChannelId === 'number') {
                defaultReportPermission = userReportsPermissions.find(x => x?.channelId === globalChannelId)?.channelPermission;
            }
            else {
                defaultReportPermission = userReportsPermissions.find(x => x?.isDefault === true)?.channelPermission;
            }
            //const defaultReportPermission = userReportsPermissions?.find((obj) => obj.isDefault == true)?.channelPermission;
            this.reportPermissionData = JSON.parse(JSON.stringify(defaultReportPermission));
            this.appMainService.isHideSpinner("ReportConfigDat");
            this.getDynamicReportMenus();
        } else {
            this.configurationService.getUserPermissionsReport(this.app.user.userId).then(res => {
                const defaultReportPermission = res.find(x => x?.isDefault === true)?.channelPermission;
                this.reportPermissionData = [];
                this.reportPermissionData = JSON.parse(JSON.stringify(defaultReportPermission));
                this.appMainService.isHideSpinner("ReportConfigDat");
                this.getDynamicReportMenus();
            });
        }

    }

    GetPermission(labels: any) {
        if (this.reportPermissionData != undefined && this.reportPermissionData.filter(c => c.objectName == labels).length > 0) {
            if (this.reportPermissionData.filter(c => c.objectName == labels)[0].permissions.filter(x => x.permissionName == 'Read')[0].statusId == 1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    GetPermissionExport(labels) {
        if (this.reportPermissionData != undefined && this.reportPermissionData.filter(c => c.objectName == labels).length > 0) {
            if (this.reportPermissionData.filter(c => c.objectName == labels)[0].permissions.filter(x => x.permissionName.toLowerCase() == 'export')[0].statusId == 1) {
                this.IsExportVisible = true;
                this.menuItems = [
                    {
                        label: 'Print',
                        icon: 'pi pi-print',
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.print)
                    },
                    {
                        label: 'Export',
                        icon: 'pi pi-upload',
                        visible: this.IsExportVisible,
                        items: [
                            {
                                label: 'PDF',
                                escape: false,
                                command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.PDF)
                            },
                            {
                                label: 'XLS',
                                escape: false,
                                command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.XLS)
                            },
                            {
                                label: 'XLSX',
                                escape: false,
                                command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.XLSX)
                            }]
                    },
                    {
                        label: 'Refresh',
                        icon: 'pi pi-refresh',
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.Refresh)
                    },
                ];
                // return true;
            }
            else {
                this.IsExportVisible = false;
                this.menuItems = [
                    {
                        label: 'Print',
                        icon: 'pi pi-print',
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.print)
                    },
                    {
                        label: 'Refresh',
                        icon: 'pi pi-refresh',
                        command: (event) => this.sendTopMenuItemAction(ReportsTopMenuItemsValues.Refresh)
                    },
                ];
            }
        }
        else {
            return false;
        }
    }

    generateMyFavMenus(myFavList: ReportsMyFavList[]) {

        const menuItems: ReportsMenus = this.reportsMenus.find(menu => menu.reportType == "myfav_reports");

        if (menuItems) {
            menuItems.items = [];

            myFavList.map(myFav => {

                let groupIndex = menuItems.items.findIndex(item => item.label == myFav.groupName);

                if (groupIndex == -1) {
                    const groupMenu: ReportsMenus = {
                        label: myFav.groupName,
                        expanded: false,
                        reportType: myFav.groupName,
                        visible: true,
                        permissionName: "",
                        route: "",
                        items: []
                    }

                    menuItems.items.push(groupMenu);
                    groupIndex = menuItems.items.length - 1;
                }

                const item: ReportsMenus = {
                    label: myFav.favTitle,
                    expanded: false,
                    escape: false,
                    visible: true,
                    reportType: myFav.reportType,
                    myFavId: myFav.id,
                    filters: myFav.filters,
                    permissionName: "",
                    route: ""
                }

                menuItems.items[groupIndex].items.push(item);
            });
        }

    }

    generateReportsMenu(MenuItems: ReportsMenus[], selectedWindow: string = "") {
        let reportsMenu: ReportsMenuFirstLevel[] = [];

        MenuItems.map(item => {
            let firstLevel: ReportsMenuFirstLevel = {
                label: item.label,
                expanded: false,
                items: []
            }

            if (item?.items?.length > 0) {
                item?.items.map(sitem => {

                    let selectedLabel = sitem.label;
                    let expanded = false;
                    if ((selectedWindow == (sitem?.reportType||sitem?.label)) && sitem.savedSearchId) {
                        selectedLabel = `<span class="selectedConfigMenuItem">${sitem.label}</span>`;
                        firstLevel.expanded = true;
                        expanded = true;
                    }

                    let secondLevel: ReportsMenuSecondLevel = {
                        label: selectedLabel,
                        expanded: expanded,
                        escape: false,
                        visible: (sitem.permissionName && sitem?.reportType) ? this.GetPermission(sitem.permissionName) : true,
                        items: [],
                        command: () => {
                            this.selectedWindow = sitem.reportType||sitem?.label;
                            if(sitem.savedSearchId){
                                this.reBuildMenu();
                                this.navigateToReport(null, sitem);
                            }
                        },
                        title: (sitem.savedSearchId ? 'Saved Search Report': ''),
                        icon: (sitem.savedSearchId ? 'fa fa-circle': ''),
                        styleClass: (sitem.savedSearchId ? 'customClass': ''),
                    }

                    if (sitem?.items?.length > 0) {
                        sitem?.items.map(titem => {
                            if (titem.reportType != "") {
                                let selectedLabel = titem.label;
                                let expanded = false;
                                if ((!this.myFavSelected && item.reportType != "myfav_reports" && selectedWindow == (titem?.reportType||titem?.label)) || (this.myFavSelected == titem.myFavId && item.reportType == "myfav_reports" && selectedWindow == titem.reportType)) {
                                    selectedLabel = `<span class="selectedConfigMenuItem">${titem.label}</span>`;
                                    firstLevel.expanded = true;
                                    secondLevel.expanded = true;
                                    expanded = true;
                                }

                                let thirdLevel: ReportsMenuThirdLevel = null;

                                if (item.reportType == "myfav_reports") {

                                    const mainReportType = this.reportsMenusFlat.find(menu => menu.reportType == titem.reportType);

                                    thirdLevel = {
                                        label: selectedLabel,
                                        expanded: expanded,
                                        escape: false,
                                        visible: mainReportType.permissionName ? this.GetPermission(mainReportType.permissionName) : true,
                                        command: () => {
                                            this.selectedWindow = titem?.reportType||titem?.label;

                                            this.myFavSelected = titem.myFavId;
                                            this.GetPermissionExport(mainReportType.permissionName);
                                            this.reBuildMenu();
                                            this.navigateToReport(mainReportType.parent.route, mainReportType, { myfav: titem.myFavId });
                                        },
                                        title: '',
                                        icon: ''
                                    }
                                } else {
                                    thirdLevel = {
                                        label: selectedLabel,
                                        expanded: expanded,
                                        escape: false,
                                        visible: (titem.permissionName && titem?.reportType) ? this.GetPermission(titem.permissionName) : true,
                                        command: () => {
                                            this.selectedWindow = titem.reportType||titem?.label;
                                            this.myFavSelected = 0;
                                            this.GetPermissionExport(titem.permissionName);
                                            this.reBuildMenu();
                                            this.navigateToReport(sitem.route, titem);
                                        },
                                        title: (titem.savedSearchId ? 'Saved Search Report': ''),
                                        icon: (titem.savedSearchId ? 'fa fa-circle': '')

                                    }
                                }
                                secondLevel.items.push(thirdLevel);
                            }
                        })
                    }
                    firstLevel.items.push(secondLevel)
                });
            }
            reportsMenu.push(firstLevel);
        });
        this.configMenu = reportsMenu;
    }

    reBuildMenu() {
        this.generateReportsMenu(this.reportsMenus, this.selectedWindow);
    }

    //print, export (PDF,XLSX)
    sendTopMenuItemAction(value: typeReportsTopMenuItemsValues) {
        this.dataService.sendData<IReportsDataServiceTopMenuModel>({ actionType: ReportsDataServiceModelValues.reportsTopMenuItems, value: value, selectedWindow: this.selectedWindow });
    }

    toogleMenuBar(){
        this.leftNavigation = !this.leftNavigation;
        this.dataService.sendData<IReportsDataServiceTopMenuModel>({ actionType: ReportsDataServiceModelValues.reportsTopMenuItems, value: ReportsTopMenuItemsValues.ReflowTable, selectedWindow: this.selectedWindow });
    }

    navigateToReport(report: string, path: any, queryParams: any = null) {
        if(path.savedSearchId){
           this.menuItems=[];
           this.savedSearchId =path.savedSearchId;
            console.log('savedSearchId', this.savedSearchId);
            console.log('path', path);
            console.log('report', report);
            console.log('queryParams', queryParams);
           this.router.navigate([`/reports`, path.route,path.id] )
           this.isSavedSearchReport = true;
        }else{
            this.isSavedSearchReport = false;
            console.log('savedSearchId', this.savedSearchId);
            console.log('path', path);
            console.log('report', report);
            console.log('queryParams', queryParams);
            // if(['getterritorywiseaccountvisithistoryofrep','getterritorywiseleadvisithistoryofrep','getaccountfieldvisithistorybyrep','getleadfieldvisithistorybyrep'].includes(path?.reportType)){
            //     report = 'visits-v2';
            // }

            this.router.navigate([`/reports/${report}`, path.route], { queryParams: queryParams });
        }
    }

}
